export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			id: "btnAddFootnote",
			type: "button",
			text: "Add Footnote",
			showIcon: "toolbar",
			icon: "plus-circle",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
		{
			id: "btnBulkImportFootnote",
			type: "button",
			text: "Bulk Import",
			showIcon: "toolbar",
			icon: "upload",
			attributes: {
				"class": "float-right-btn btn btn-secondary"
			},
		},
		{
			id: "tagFMVStatement",
			type: "button",
			text: "Tag FMV Statement",
			showIcon: "toolbar",
			icon: "toolbar-float",
			attributes: {
				"class": "float-right-btn btn btn-tertiary"
			},
		},



	]
}